module.exports = __webpack_public_path__ + "img/vote-5.1ce5f60d.png";